import { SnippetType } from '@distribute/shared/types';

export const formatSnippetType = (type: SnippetType) => {
  switch (type) {
    case 'text':
      return 'Text';
    case 'image':
      return 'Image';
    case 'video':
      return 'Video';
    case 'file':
      return 'File';
    default:
      return '';
  }
};
